import ImgLogo from 'assets/img/logo/logo-page.png';
import React from 'react';
import { Link } from 'react-router-dom';

const BreadCurmb = ({
  title,
  subtitle,
  noRedireccionar = true,
  showPaths = true,
  infoAdicional = null,
}) => (
  <React.Fragment>
    <div className="row mx-1 mx-sm-0" style={{ paddingBottom: '0px' }}>
      <div className="col-sm-8 col-lg-9">
        {noRedireccionar && (
          <Link to={`/`}>
            <img src={ImgLogo} className="img-logo-page" alt="" loading="lazy"></img>
          </Link>
        )}
        {noRedireccionar === false && <img src={ImgLogo} className="img-logo-page" alt=""></img>}
      </div>
      {showPaths && (
        <div className="col-sm-4 col-lg-3">
          <div className={'title-breadcum-cot'}>{title}</div>
          <div className={'subtitle-breadcum-cot'}>
            {noRedireccionar && <Link to={`/`}>Inicio / </Link>}
            {subtitle}
          </div>
          {infoAdicional && <div className={'subtitle-breadcum-cot'}>{infoAdicional}</div>}
        </div>
      )}
    </div>
  </React.Fragment>
);
export default BreadCurmb;
